"use strict";
/**
 * =================================
 * color 設定
 * WARNING: デザイナーさんと相談中のため現状は使用しない（参考のみ）
 * =================================
 */
/**
 * ---------------------------------
 * colors (色一覧)
 * ---------------------------------
 */
// base color: 100
const singleColors = {
    black: {
        700: '#000',
    },
    blue: {
        100: '#4483ba',
        75: '#70bbd8',
    },
    'blue-gray': {
        100: '#a1a7b2',
        200: '#5f6673',
        300: '#313c4f',
        400: '#1c283d',
        75: '#f0f4f8',
    },
    'coral-pink': {
        100: '#ee5959',
        75: '#ebae97',
    },
    gray: {
        100: '#f0f0f0',
        200: '#e7e7e7',
        300: '#d6d6d6',
        400: '#bdbdbd',
        50: '#fff',
        500: '#777',
        600: '#333',
        700: '#262626',
        75: '#f9f9f9',
    },
    navy: {
        100: '#00154f',
        200: '#011039',
        300: '#000c2b',
    },
    orange: {
        100: '#f2a115',
        200: '#e38710',
        300: '#cb7504',
        50: '#fff9ee',
    },
    red: {
        100: '#c00000',
        50: '#fff2f2',
    },
    'turquoise-blue': {
        100: '#23a8c4',
        200: '#1e91aa',
        300: '#1e8aa1',
        50: '#d9ebfb',
    },
    'turquoise-green': {
        100: '#6fc2ba',
        50: '#d9f1ee',
    },
};
const gradientColors = {
    'dark-green': {
        from: '#437681',
        to: '#1c283d',
    },
    'dark-rainbow': {
        from: '#00b5dc',
        to: '#fb7c00',
        via: '#ebe24c',
    },
    'lite-blue': {
        from: '#29c3c8',
        to: '#069ad2',
    },
};
const colors = Object.assign(Object.assign({ current: 'currentColor', inherit: 'inherit', transparent: 'transparent' }, singleColors), { gradient: Object.assign({}, gradientColors) });
/**
 * ---------------------------------
 * extend colors
 * ---------------------------------
 */
/**
 * テキスト色
 * WARNING: src/components/ui/Typography/Body/Text/Text.tsx の色設定 と同じにする
 * WARNING: 基本的には Text コンポーネントを使用してください
 */
const extendTextColor = {
    base: colors.gray['600'],
    black: colors.black['700'],
    error: colors.red['100'],
    inactive: colors.gray['400'],
    link: colors['turquoise-blue']['100'],
    primary: colors.navy['100'],
    secondary: colors.orange['100'],
    textGray: colors.gray['500'],
    white: colors.gray['50'],
};
// 背景色
const extendBackgroundColor = {
    'base-gray': colors.gray['100'],
    black: colors.black['700'],
    emphasis: colors.orange['50'],
    info: colors['blue-gray']['75'],
    'light-gray': colors.gray['75'],
    white: colors.gray['50'],
};
// border
const extendBorderColor = {
    dark: colors.gray['300'],
    light: colors.gray['100'],
};
module.exports = {
    colors,
    extend: {
        backgroundColor: extendBackgroundColor,
        borderColor: extendBorderColor,
        textColor: extendTextColor,
    },
};
